module.exports = __webpack_public_path__ + "static/media/loughborough.cbbd8fea.png";